module.exports = __webpack_public_path__ + "img/coffeetogocreativeart.e90bb814.jpg";